import styled from 'styled-components';
import { color, units } from '@m/alchemy-ui/theme';
import { useFormState } from 'react-hook-form';

const ErrorMessage = styled.p.attrs({ role: 'alert' })`
  color: ${color('base', { palette: 'interactiveDestructive' })};
  margin-top: ${units(2)};
`;

export function ReactHookFormError({ control, name }) {
  const { errors } = useFormState({ control });
  const errorMessage = errors?.[name]?.message;

  return errorMessage ? (
    <ErrorMessage role="alert">{errorMessage}</ErrorMessage>
  ) : null;
}
